export const FILTER_FORMAT = "YYYY-MM-DDTHH:mm";
export const LOG_ENTRY_FORMAT = "DD.MM.YYYY HH:mm:ss";
export const CREATED_AT_FORMAT = "YYYY-MM-DD-HH:mm:ss";
